import React from "react";

interface TabNavProps {
  onClick: () => void;
  disabled?: boolean;
}

const BackButton: React.FC<TabNavProps> = ({ onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`mb-4 inline-flex items-center gap-2 px-4 py-1 rounded-md ${
        disabled
          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
          : "bg-[#F7F7F7] hover:bg-[#000] hover:text-white border border-[#000] text-[#000] font-semibold shadow transition-all duration-150"
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 19l-7-7 7-7"
        />
      </svg>
      Back to List
    </button>
  );
};

export default BackButton;
